import Breakpoint from '~/data/Breakpoint'

export default function (breakpoint: Breakpoint): number {
    if (breakpoint === Breakpoint.default || breakpoint === Breakpoint.sm) {
        return 6
    }

    return 16
}
